export default function checkImageSize(
  file: File,
  width: number,
  height: number,
) {
  return new Promise((resolve, reject) => {
    let img = new Image()

    img.onload = () => {
      if (img.width !== 618 || img.height !== 618) {
        resolve(false)
      } else {
        resolve(true)
      }
      window.URL.revokeObjectURL(img.src)
    }
    img.src = window.URL.createObjectURL(file)
  })
}
